var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8086,
    cy: 12.1169,
    r: 12,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9515 13.1169H7.66574C7.19431 13.1169 6.80859 12.6669 6.80859 12.1169C6.80859 11.5669 7.19431 11.1169 7.66574 11.1169H17.9515C18.4229 11.1169 18.8086 11.5669 18.8086 12.1169C18.8086 12.6669 18.4229 13.1169 17.9515 13.1169Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.d11d2c37623b97ad053af3d789911388.svg";
export { ForwardRef as ReactComponent };